// extracted by mini-css-extract-plugin
export default {"Chatbot":"Bot_Chatbot__E2Srd","cierre":"Bot_cierre__fzgMf","button":"Bot_button__g9YHX","buttonContainer":"Bot_buttonContainer__iZS4-"};